import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1
  }
  100% {
    opacity: 0
  }
`;

export const plopDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-10px);
  } 50% {
    transform: translateY(5px);
  } 100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const plopUp = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0px);
  } 50% {
    transform: translateY(5px);
  } 100% {
    transform: translateY(-10px);
    opacity: 0;
  }
`;
